import {
  createDirectus,
  rest,
  readItems,
  deleteItem,
  authentication,
} from "@directus/sdk";

const client = createDirectus(location.origin)
  .with(authentication("cookie"))
  .with(rest());

async function get(filter, fields) {
  let obj = {
    fields: fields ? fields : ["*"],
  };
  if (filter && Object.keys(filter).length !== 0) {
    obj.filter = filter;
  }

  const data = await client.request(readItems("persons", obj));
  return data;
}

async function checkEmail(email, id) {
  let filter = { email: { _eq: email } };
  if (id) {
    filter = {
      _and: [
        {
          email: {
            _eq: email,
          },
        },
        {
          id: {
            _neq: id,
          },
        },
      ],
    };
  }
  return await client.request(readItems("persons", { filter }));
}
async function deleteById(id) {
  return await client.request(deleteItem("persons", id));
}
export default {
  checkEmail,
  deleteById,
  get,
};
